import { installGlobal, type NuklieChatGlobal } from './core';

/**
 * `/webchat/v1/chat.js` — a entrada pública.
 *
 * A origem do iframe e da API do widget é a MESMA de onde este arquivo foi servido: quem instala copia
 * uma tag e nada mais. Ver `web/docs/webchat.md`.
 */
declare const __WEBCHAT_VERSION__: string;

(function start() {
  const win = window as Window & { NuklieChat?: NuklieChatGlobal };

  // Duas tags do script na mesma página: a segunda não substitui a primeira.
  if (win.NuklieChat?.version) return;

  const atual = document.currentScript as HTMLScriptElement | null;
  const src = atual?.src
    ?? Array.from(document.querySelectorAll<HTMLScriptElement>('script[src*="/webchat/v1/chat.js"]')).pop()?.src
    ?? '';

  let origem: string;
  try {
    origem = new URL(src).origin;
  } catch {
    console.error('[NuklieChat] Não foi possível descobrir a origem do chat.js.');

    return;
  }

  installGlobal(win, origem, typeof __WEBCHAT_VERSION__ === 'string' ? __WEBCHAT_VERSION__ : 'dev');
})();
